<template>
  <FormInput :model-value="data?.job_title" @update:modelValue="updateData('job_title', $event)"
             label="What job title would you like to add?" placeholder="Job title" required/>
  <FormTextarea :model-value="data?.description" @update:modelValue="updateData('description', $event)"
                label="Provide additional details" placeholder="e.g. What industries does it belong to? Describe it here." class="mt-4"/>
</template>

<script setup>
import FormInput from "./FormInput.vue";
import FormTextarea from "./FormTextarea.vue";
import {onMounted} from "vue";

const emits = defineEmits(["update:data"]);
const props = defineProps({
  data: Object,
  meta: Object,
});

const updateData = (key, value) => {
  emits("update:data", {
    ...props.data,
    [key]: value,
  });
};


onMounted(() => {
  if (props.meta?.search && !props.data?.job_title) updateData("job_title", props.meta.search);
});
</script>
